











import { Component, Vue } from "vue-property-decorator";
import ChargeAccount from "@/components/ChargeAccount.vue";

@Component({
  components: {
    ChargeAccount
  }
})
export default class Charge extends Vue {}
